import breakpoints from './../breakpoints'

export default {
  ...breakpoints,
  large: {
    ...breakpoints.large,
    width: 951
  }
}
